import React from 'react';
import { css } from '@linaria/core';
import Button from '../components/Button';
import Container from '../components/Container';

const errorMessage = css`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
  flex-wrap: wrap;
  max-width: 650px;
  padding: 20px;
  margin-left: auto;
  margin-right: auto;
  border: 1px solid #b62126;
`;

const errorMessageTitle = css`
  color: #b62126;
  margin-top: 0;
`;

const errorMessageDescription = css`
  color: #b62126;
  margin-top: 10px;
  margin-bottom: 20px;
  line-height: 28px;
`;

const errorButton = css`
  width: 100%;

  @media (min-width: 500px) {
    width: auto;
  }
`;

const ErrorView = () => (
  <Container>
    <div className={errorMessage}>
      <h3 className={errorMessageTitle}>Something went wrong!</h3>
      <p className={errorMessageDescription}>
        We are unable to show you any search results at the moment, please try
        again later.
      </p>
      <Button
        className={errorButton}
        onClick={() => {
          window.location.href = 'https://historicengland.org.uk';
        }}
        variant="primary"
      >
        Back to homepage
      </Button>
    </div>
  </Container>
);

export default function ErrorBoundaryContent(props) {
  if (props.error) {
    return <ErrorView />;
  }
  return props.children;
}
